export default __webpack_public_path__ + "static/media/Avanade Color Logo RGB.211b6e65.png";